import { render, staticRenderFns } from "./batchEditDialog.vue?vue&type=template&id=65ad3c70&scoped=true&"
import script from "./batchEditDialog.vue?vue&type=script&lang=js&"
export * from "./batchEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./batchEditDialog.vue?vue&type=style&index=0&id=65ad3c70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad3c70",
  null
  
)

export default component.exports